import BaseTableController from './base_table_controller';

// dp_id 2289 — data_grid: { rows: [{ disclosure }] }
export default class extends BaseTableController {
  static values = { disclosureOptions: Array };

  searchableFields = ['disclosure'];

  connect() {
    const rows = this.initialDataValue?.rows;
    this.rows =
      Array.isArray(rows) && rows.length > 0
        ? rows.map((r) => ({ disclosure: r.disclosure ?? '' }))
        : [this.emptyRow()];
    this.renderRows();
    this.syncHiddenField();
  }

  emptyRow() {
    return { disclosure: '' };
  }

  updateField(event) {
    const el = event.currentTarget;
    const index = parseInt(el.dataset.rowIndex, 10);
    this.rows[index].disclosure = el.value;
    // Re-render so other dropdowns exclude the newly selected disclosure
    this.renderRows();
    this.syncHiddenField();
  }

  buildRow(row, index) {
    const tr = document.createElement('tr');

    const usedValues = new Set(
      this.rows.filter((r, i) => i !== index && r.disclosure).map((r) => r.disclosure)
    );
    const availableOptions = this.disclosureOptionsValue.filter((opt) => !usedValues.has(opt));

    tr.appendChild(
      this.buildSelectCell(row, index, 'disclosure', availableOptions, { fullWidth: true })
    );
    tr.appendChild(this.buildRemoveButton(index));

    return tr;
  }
}
